// extracted by mini-css-extract-plugin
module.exports = {"success":"_1M_A5JkbBxCoaBdQE95Ima","warning":"_3BXDuAhbQk17hoXWnHZj1-","danger":"_2N06PqTscUuOZFg9OvWxO9","container":"O1tcmSXj8YgHWThqz0tET"};